<template>
  <div id="app">
    <v-overlay
        :opacity="0.5"
        :value="loading"
        z-index="100000"
    >
      <v-progress-circular indeterminate size="100">
        {{$t('loading')}}...
      </v-progress-circular>
    </v-overlay>
    <router-view></router-view>
    <SvgSprite/>
  </div>
</template>

<script>
import SvgSprite from '@/components/SvgSprite'


export default {
  name: 'App',
  components: {SvgSprite},
  data: () => ({
    interval: null 
  }),
  mounted(){
    setInterval(() => this.$store.state.time = new Date(), 60000)
  },
  beforeDestroy(){
    clearInterval(this.interval)
  },
  computed: {
    loading: function (){
      return this.$store.state.loader;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/style";
@import "~toastr/toastr";
@import "./libs/customScrollbar/vueScrollbar.css";

.disabled{
  pointer-events: none;
  filter: grayscale(1);
}

</style>